(function () {
  class FreeSpinsUpgradePopup extends PIXI.Container {
    constructor() {
      super();

      this.visible = false;

      this._level = 0;
      this._callback = undefined;

      const self = this;
      messageBus.subscribe("spinner:GameConfigEvent", function () {
        self.onLayoutComplete();
      });
    }

    onLayoutComplete() {
      this._upgradeBacker = resourceManager.get("upgradeBacker");
      this._upgradeBacker.alpha = 0;
      this._upgradeBacker.visible = false;

      this._numSpins = resourceManager.get("upgradePopup:FreeSpinsUpgradePopup:numFreeSpins");
      this._numSpins.setTranslationParameters(10);

      this._pressStartBox = resourceManager.get("upgradePopup:FreeSpinsUpgradePopup:pressStartColourBox");
      this._pressStartBox.alpha = 0;
      this._pressStartBox.visible = false;
      this._pressStartBox.interactive = false;

      this._level2 = resourceManager.get("upgradePopup:FreeSpinsUpgradePopup:level2");

      this._level3 = resourceManager.get("upgradePopup:FreeSpinsUpgradePopup:level3");
      this._level3.visible = false;

      this._level4 = resourceManager.get("upgradePopup:FreeSpinsUpgradePopup:level4");
      this._level4.visible = false;

      const continueText = resourceManager.get("upgradePopup:FreeSpinsUpgradePopup:continueContainer");

      gsap.to(continueText, {
        duration: 0.8,
        pixi: { scaleX: 0.92, scaleY: 0.92 },
        yoyo: true,
        repeat: -1,
        ease: "power1.inOut",
      });
    }

    setup() {
      this._pressStartBox.visible = true;
      this._pressStartBox.alpha = 0;
    }

    switchFish(level) {
      musicManager.setFreeSpinsLevel(level - 1);

      switch (level) {
        default:
          this._level2.visible = false;
          this._level3.visible = false;
          this._level4.visible = false;
          break;

        case 2:
          this._level2.visible = true;
          this._level3.visible = false;
          this._level4.visible = false;
          break;

        case 3:
          this._level2.visible = false;
          this._level3.visible = true;
          this._level4.visible = false;
          break;

        case 4:
          this._level2.visible = false;
          this._level3.visible = false;
          this._level4.visible = true;
          break;
      }
    }

    showUpgradePopup(level, callback) {
      this.visible = true;

      gameController.canSlamStop = false;

      this.setup();

      this._callback = callback;

      this.switchFish(level);

      this._upgradeBacker.alpha = 0;
      this._upgradeBacker.visible = true;
      this.fadeIn(this._upgradeBacker, 0.5, 1, 0);

      this.floatIn(this, 0, 1.5);
      this.fadeIn(this, 1, 0.3, 0, () => {
        soundManager.play("maxWin");
      });

      let self = this;
      timerManager.addTimeout(1000, function () {
        self.setActive();
      });

      soundManager.play("dialogIn");
    }

    floatIn(object, delay, duration) {
      gsap.fromTo(
        object,
        {
          x: 0,
          y: 500,
        },
        {
          delay,
          duration,
          ease: "elastic.out(1.0, 0.4)",
          x: 0,
          y: 0,
        }
      );
    }

    fadeIn(object, alpha, duration, delay, cb = undefined) {
      gsap.fromTo(
        object,
        {
          alpha: 0,
        },
        {
          delay: delay,
          duration: duration,
          alpha: alpha,
          onStart: () => {
            object.visible = true;
          },
          onComplete: () => {
            if (cb) {
              cb();
            }
          },
        }
      );
    }

    bounceIn(object, delay, duration, scale) {
      gsap.fromTo(
        object.scale,
        {
          x: 0,
          y: 0,
        },
        {
          delay: delay,
          duration: duration ?? 1,
          ease: "Bounce.easeOut",
          x: scale ?? 1,
          y: scale ?? 1,
          onStart: () => {
            object.visible = true;
            object.alpha = 1;
          },
          onComplete: () => {
            this.setActive();
          },
        }
      );
    }

    setActive() {
      this._pressStartBox.interactive = true;
      this._pressStartBox.mousedown = this._pressStartBox.touchstart = this.closeDialog.bind(this);
    }

    closeDialog() {
      this._pressStartBox.visible = false;
      this._pressStartBox.alpha = 0;
      this._pressStartBox.interactive = false;
      this._pressStartBox.mousedown = this._pressStartBox.touchstart = undefined;

      soundManager.play("buttonPressV1");

      soundManager.play("dialogOut");

      this.clearIntro();
    }

    clearIntro() {
      this.fadeOut(this._upgradeBacker, 1.0);
      this.fadeOut(this, 1);
      this.riseUp(this, 1);

      const self = this;
      timerManager.addTimeout(1000, function () {
        self._callback();
      });
    }

    fadeOut(object, duration) {
      gsap.to(object, {
        duration: duration,
        alpha: 0,
        ease: "power1.in",
        onComplete: () => {
          object.visible = false;
          object.alpha = 1;
        },
      });
    }

    riseUp(object, duration, cb) {
      const originalPosition = {
        x: gsap.getProperty(object, "x"),
        y: gsap.getProperty(object, "y"),
      };

      gsap.to(object, {
        duration: duration,
        x: 0,
        y: -1000,
        ease: "power4.in",
        onComplete: () => {
          object.visible = false;
          gsap.set(object, { x: originalPosition.x, y: originalPosition.y });
          if (cb) {
            cb();
          }
        },
      });
    }
  }

  let freeSpinsUpgradePopupCreator = function (json) {
    return new FreeSpinsUpgradePopup();
  };

  let freeSpinsUpgradePopupInitialiser = function (json) {};

  let freeSpinsUpgradePopupFilesRequired = function () {
    return [];
  };

  resourceManager.registerObjectType(
    "FreeSpinsUpgradePopup",
    freeSpinsUpgradePopupCreator,
    freeSpinsUpgradePopupInitialiser,
    freeSpinsUpgradePopupFilesRequired
  );
})();
